import {ListBox} from "primereact/listbox";
import {AvailableSlot} from "../data/Slot";
import {ReactNode} from "react";
import {format} from "date-fns";
import {Nullable} from "primereact/ts-helpers";
import {Panel} from "primereact/panel";
import {Knob} from "primereact/knob";

const slotTemplate = (slot: AvailableSlot): ReactNode => {
    const header = `${format(slot.startDateTime, "HH:mm")} - ${format(slot.endDateTime, "HH:mm")} `;

    return (
        <div className="flex">
            <div className="flex-grow-1 flex align-items-center justify-content-left">
                <div class-name="flex flex-column">
                    <div className="flex align-items-center my-1">{header}</div>
                    {slot.comment && (
                        <div className="flex align-items-center">
                            <p className="text-color-secondary text-sm p-0 my-1">
                                {slot.comment}
                            </p>
                        </div>
                    )}
                </div>
            </div>
            {!slot.disabled &&
                <div className="flex-none w-6rem">
                    <Knob
                        readOnly
                        value={slot.capacity - slot.available}
                        max={slot.capacity}
                        size={75}
                        valueColor="var(--red-500)"
                        rangeColor="var(--green-300)"
                        valueTemplate={"{value}/" + slot.capacity}
                    />
                </div>}
            {slot.disabled && (
                <div className="flex-none flex align-items-center justify-content-center w-6rem h-5rem">
                    <i className="pi pi-lock text-gray-500 text-3xl"/>
                </div>
            )}
        </div>
    );
};

function SlotsComponent({
                            selectedSlot,
                            selectedDate,
                            slots,
                            onSlotSelected,
                        }: {
    selectedSlot: Nullable<AvailableSlot>;
    selectedDate: Date;
    slots: AvailableSlot[];
    onSlotSelected(slot: AvailableSlot): void;
}) {
    return (
        <Panel header={"Tag: " + format(selectedDate, "dd.MM.yyyy")}>
            <ListBox
                value={selectedSlot}
                onChange={(e) => onSlotSelected(e.value)}
                options={slots}
                itemTemplate={slotTemplate}
                className="w-full"
                optionDisabled={(e) => e.disabled || e.available == 0}
            />
        </Panel>
    );
}

export default SlotsComponent;
